module.exports = __webpack_public_path__ + "static/img/pic_tupianyasuo_big@2x.93b7ba4a.png";